export const planOptions = {
    free: [
        {
            id: 1,
            description: 'Access to free courses'
        },
        {
            id: 2,
            description: 'Limited access to skill tree'
        },
        {
            id: 3,
            description: 'Explore job board'
        },
        {
            id: 4,
            description: 'Join our LinkedIn community'
        }
    ],
    premium: [
        {
            id: 1,
            description: '45+ pharma expert courses'
        },
        {
            id: 2,
            description: 'ISO 9001-backed certifications'
        },
        {
            id: 3,
            description: 'Monthly VIP career coaching'
        },
        {
            id: 4,
            description: 'Pharma resume builder'
        },
        {
            id: 5,
            description: 'Pharma cover letter builder'
        },
        {
            id: 6,
            description: 'Full skill tree access'
        },
        {
            id: 7,
            description: 'Personalized pharma career path'
        }
    ],

}